export const appConstants = {
  INITIALIZE: "APP_INITIALIZE",
  RECEIVED_CONFIG: "APP_RECEIVED_CONFIG",
  RELOAD_CONFIG: "APP_RELOAD_CONFIG",
};

